 
export const getCommitmentForCircle=(state, circleId)=>{    
    const commitments = state.commitments.commitments;
    return commitments[circleId]?commitments[circleId] : undefined;
}

export const isAgreementLoading=(state)=>{
    return state.commitments.loading;
}
 
export const userHasCommitment=(state, circleId, userId)=>{
    const circle_commitments = getCommitmentForCircle(state, circleId);
    if(!circle_commitments){
        return false;
    }
    const commitments = circle_commitments.filter(commitment=>(commitment.user_guid===userId));
    if(commitments.length === 1){
        return true
    }   
    
    return false;

}

export const userWhoSignedCommitment=(state, circleId)=>{
    const circle_commitments = getCommitmentForCircle(state, circleId);
    if(!circle_commitments){
        return []
    }else{
       return circle_commitments.map(commitment=>(commitment.user_guid));
    }
}